import React from 'react';


const Footer = ({ boxShadow }) => {
  const footerStyle = {
    backgroundColor: "#245073",
    color: "#ffffff",
    padding: "15px 0", // Dramatically reduced padding
    boxShadow: boxShadow || "0px -4px 10px rgba(0,0,0,0.1)",
    fontFamily: "'Inter', sans-serif",
    fontSize: "0.85rem" // Slightly smaller base font for a compact look
  };

  const linkStyle = {
    color: "#a5d8ff",
    textDecoration: "none",
    fontWeight: "500"
  };

  const labelStyle = {
    color: "#d1d1d1",
    marginRight: "5px"
  };

  return (
    <footer className="footer-box" style={footerStyle}>
      <div className="container">
        <div className="row align-items-center">
          
          {/* Brand & Contacts in a tighter row */}
          <div className="col-md-8 text-center text-md-start">
            <div className="d-flex flex-column flex-md-row align-items-center">
              <strong style={{ fontSize: "1rem", marginRight: "20px", letterSpacing: "0.5px" }}>
                WorkWise - UAE
              </strong>
              
              <div className="mx-md-3">
                <span style={labelStyle}>Email:</span>
                <a href="mailto:workwise@mastersystems.com" style={linkStyle}>
                  workwise@mastersystems.com
                </a>
              </div>

              <div className="mx-md-3">
                <span style={labelStyle}>Phone:</span>
                <span style={{ fontWeight: "500" }}>+971 588 191 579</span>
              </div>
            </div>
          </div>

          {/* Social Icons - Compact */}
          <div className="col-md-4 text-center text-md-end mt-2 mt-md-0">
            <a 
              href="https://www.linkedin.com/company/master-systems-international" 
              style={{ fontSize: "1.2rem", color: "white" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-linkedin-square" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        {/* Ultra-slim Copyright border */}
        <div className="row mt-2 pt-2" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <div className="col-12 text-center">
            <p style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.5)", margin: 0 }}>
              &copy; {new Date().getFullYear()} Master Systems International. | Version 5.0.2 Stable
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

